import { useProcedureAssignmentSettingRuleSet as useCommonHook } from "../common/hooks";
import { AssignmentSettingRuleSetInput } from "../../../../../application/domain/procedure-assignment-setting-ruleset/procedure-assignment-setting-ruleset";
import apiClient from "../../../../../application/apis/api-client";
import { reportUnexpectedError } from "@graffer-inc/smart-apply";
import { toast } from "react-toastify";
import { SmartApplyR } from "../../route";

export const useProcedureAssignmentSettingRuleSetCreate = () => {
  const hookResult = useCommonHook();
  const {
    rulesetName,
    description,
    targetFields,
    rules,
    validateFormData,
    auth,
    setIsLoading,
    history,
  } = hookResult;

  const handleSave = async () => {
    const isValid = validateFormData();

    if (!isValid) {
      return;
    }

    const input: AssignmentSettingRuleSetInput = {
      tenantId: auth.orgId,
      name: rulesetName,
      description,
      targetFields,
      rules,
    };

    setIsLoading(true);
    try {
      await apiClient.createProcedureAssignmentSettingRuleSet(input);
      toast.success("申請振り分け設定が保存されました。");
      history.push(SmartApplyR.AssignmentSettingRulesets.link({}));
    } catch (error) {
      reportUnexpectedError(error);
      toast.error("申請振り分け設定の保存に失敗しました。");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    ...hookResult,
    handleSave,
  };
};
